import React from "react";
import {Link} from "react-router-dom";
import styles from "./NewBreadcrumbs.module.css";

export interface BreadcrumbItem {
    label: string;
    href?: string;
    icon?: React.ReactNode;
}

interface NewBreadcrumbsProps {
    items: BreadcrumbItem[];
    isAdmin: boolean;
}

export const NewBreadcrumbs: React.FC<NewBreadcrumbsProps> = ({items, isAdmin}) => {
    const baseUrl = isAdmin ? "/administrator/cabinet" : "/user/cabinet";

    if (!items || items.length === 0) return null;

    return (
        <nav className={styles.breadcrumbs}>
            {items.map((item, idx) => {
                const isLast = idx === items.length - 1;
                const link = item.href
                    ? `${baseUrl}${item.href.startsWith("/") ? "" : "/"}${item.href}`
                    : undefined;

                return (
                    <React.Fragment key={idx}>
                        {item.icon && <span className={styles.icon}>{item.icon}</span>}
                        {link && !isLast ? (
                            <Link to={link} className={styles.breadcrumbLink}>
                                {item.label}
                            </Link>
                        ) : (
                            <span className={styles.currentBreadcrumb}>{item.label}</span>
                        )}
                        {!isLast && <span className={styles.separator}>{">"}</span>}
                    </React.Fragment>
                );
            })}
        </nav>
    );
};
